// extracted by mini-css-extract-plugin
export default {"searched":"ProductSearched_searched__AVA+s","productsCardsContainer":"ProductSearched_productsCardsContainer__YW-pP","productsContainer":"ProductSearched_productsContainer__jU1VU"};